import React from 'react';
import ReactDOM from 'react-dom/client';
import { App } from './App';
import './styles/index.less';
import { applyTheme } from './theme';

const params = new URLSearchParams(window.location.search);

const currency = params.get('currency') ?? undefined;
const locale = params.get('locale') ?? undefined;

params.delete('currency');
params.delete('locale');

applyTheme(params);

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <App currency={currency} locale={locale} />
  </React.StrictMode>
);
